import { Stack } from "@mui/material"
import { useField } from "formik"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { FormikCurrencyField } from "../../../../../../modules/merchant/admin/products/components/FormikCurrencyField"
import { StandardButton } from "../../../../buttons/StandardButton"
import { FormikNumberField, FormikTextField } from "../../../../forms/Formik"
import { ProductWishFormValues } from "./ProductWishForm"
import { MAX_NAME_LENGTH, MAX_PRICE_VALUE } from "../../../../../../constants/inputValidationDefaults"

type ProductWishFormContentProps = Readonly<{
    isShowPriceField: boolean
}>

export function ProductWishFormContent({ isShowPriceField }: ProductWishFormContentProps) {
    const [, metaPrice] = useField<ProductWishFormValues["price"]>("price")

    return (
        <Stack gap="1.5rem" alignItems="flex-start">
            <LocalizedStrict
                id="create-order-wish-dialog-product-name-field"
                attrs={{ label: true, placeholder: true }}
            >
                <FormikTextField<ProductWishFormValues>
                    name="name"
                    label="Product name *"
                    placeholder="Enter product name:"
                    fullWidth
                    inputProps={{ maxLength: MAX_NAME_LENGTH }}
                />
            </LocalizedStrict>
            <LocalizedStrict
                id="create-order-wish-dialog-product-items-field"
                attrs={{ label: true, placeholder: true }}
            >
                <FormikNumberField<ProductWishFormValues>
                    label="Product items *"
                    placeholder="Enter items:"
                    name="quantity"
                    integerOnly
                    maxLength={6}
                />
            </LocalizedStrict>
            {isShowPriceField && (
                <Stack>
                    <LocalizedStrict
                        id="create-order-wish-dialog-product-price-field"
                        attrs={{ label: true, placeholder: true }}
                    >
                        <FormikCurrencyField
                            name="price"
                            label="Product price *"
                            placeholder="Enter price (DKK):"
                            errorMessage={metaPrice.error}
                            fullWidth={false}
                            inputTextAlign="left"
                            containerDirection="column"
                            gap={0.25}
                            isAllowed={({ floatValue }) => floatValue === undefined || floatValue <= MAX_PRICE_VALUE}
                        />
                    </LocalizedStrict>
                </Stack>
            )}
            <Stack flexDirection="row" justifyContent="center" width="100%">
                <LocalizedStrict id="create-order-wish-dialog-submit-button">
                    <StandardButton fullWidth={false} type="submit">
                        Confirm
                    </StandardButton>
                </LocalizedStrict>
            </Stack>
        </Stack>
    )
}
